// src/components/table/TableCanvas.jsx
import { useDispatch } from "react-redux";

import PusherHandler from "@/api/lib/pusher/PusherHandler";
import { useEffect } from "react";
import { getBookingById } from "@/api/table-floor/tableFloor";
import { addBookingToTable, removeBookingFromTable, updateTablePendingBookingCount, updateTableStatus } from "@/redux/slice/table-slice/table-slice";
import { addNewBookingToDetails, setSelectedBookingTable, updateBookingStatusInDetails } from "@/redux/slice/table-slice/booking-table-slice";
import { updateLiveBookingDetailsBookingStatus } from "@/redux/slice/table-slice/live-table-slice";
import { addNewReservation, updateReservationState } from "@/redux/slice/reservation-slice/reservation-slice";
import { getReservationById } from "@/api/new-api/reservations/reservation";

function ReservationPusher() {
  const dispatch = useDispatch();
  
  const {
      connectionStatus: tableStatus,
      lastUpdate: lastTableUpdate,
      addEventHandler: addTableHandler,
      isConnected: tableConnected
  } = PusherHandler(); 

  useEffect(() => {
    console.log('🚀 Setting up table event handlers...');
    console.log('📡 Table connection status:', tableStatus);
    console.log('🔗 Is table connected:', tableConnected);
    
    addTableHandler('reservation_created', (data) => {

      console.log('📥 Received reservation_created event:', data);

      getReservationById(data.reservation_id)
        .then(res => {
          if (res.status === 'success') {
            const reservation = res.data?.reservation;
            if (reservation) {
              dispatch(addNewReservation(reservation));
            } else {
              console.warn('⚠️ Reservation details not found for ID:', data.reservation_id);
            }
          } else {
            console.error('❌ Failed to fetch reservation details:', res.message);
          }
        })
        .catch(err => {
          console.error('❌ Error fetching reservation details:', err);
        });
    });

    addTableHandler('reservation_updated', (data) => {

      console.log('📥 Received reservation_updated event:', data);

      getReservationById(data.reservation_id)
        .then(res => {
          if (res.status === 'success') {
            const reservation = res.data?.reservation;
            if (reservation) {
              dispatch(updateReservationState(reservation));
            } else {
              console.warn('⚠️ Reservation details not found for ID:', data.reservation_id);
            }
          } else {
            console.error('❌ Failed to fetch reservation details:', res.message);
          }
        })
        .catch(err => {
          console.error('❌ Error fetching reservation details:', err);
        });
    });

    const handleLiveReservation = (data) => {
      console.log('📥 Received live reservation event:', data);
      const reservationId = data?.reservation_id || data?.id;
      if (reservationId) {
        getReservationById(reservationId)
          .then(res => {
            if (res.status === 'success') {
              const reservation = res.data?.reservation || res.data;
              if (reservation) {
                dispatch(updateReservationState(reservation));
              } else {
                console.warn('⚠️ Reservation details not found for ID:', reservationId);
              }
            } else {
              console.error('❌ Failed to fetch reservation details:', res.message);
            }
          })
          .catch(err => {
            console.error('❌ Error fetching reservation details on live update:', err);
          });
      }
    };

    addTableHandler('live-reservation-update', handleLiveReservation);
    addTableHandler('reservation_deposit_paid', handleLiveReservation);
  }, [addTableHandler, tableStatus, tableConnected, dispatch]);

  return (
    <div>

    </div>
  );
}


export default ReservationPusher;